<template>
    <div class="set-two-step-auth d-flex-c-jsb-ast-gap15 l-radius">
        <h3 class="label d-flex-ac-jfs-gap10">
            <i class="icon gradient-template-gold-trans-linear back xs-radius"/>
            شناسایی دو عاملی
        </h3>
        <p>
            برای امنیت بیشتر حساب کاربری, فعالسازی شناسایی دو عاملی توصیه میشود.
            <br/>
            تایید هویت دو مرحله ای جهت ورود به حساب
            کاربری و درخواست برداشت از روشی که انتخاب میکنید به شما اطلاع رسانی می شود.
        </p>
        <form @change="showModal" class="d-flex-r-w-jfs-ast-g0-gap15 m-font">
            <label class="two-step-radio d-flex-r-jfs-ac-gap10 px-15" v-for="option in options"
                   :key="option.name +twoStep">
                <input type="radio" v-model="twoStep" :value="option.value" hidden>
                <span>
                    <i></i>
                </span>
                <b/>
                {{option.name}}
            </label>
        </form>
        <SetTwoStepAuthModal @close="getTwoStepAuth()" @submit="submitted"
                             :qr-code="qrCode" :qr-link="qrLink" :mobile="mobile" v-model="modal"
                             :type="options.find(e => e.value===twoStep)"/>
    </div>
</template>

<script>
    import SetTwoStepAuthModal from "@/components/Panel/Setting/SetTwoStepAuth/SetTwoStepAuthModal";

    export default {
        name: "SetTwoStepAuth",
        components: {SetTwoStepAuthModal},
        data() {
            return {
                modal: false,
                twoStep: 'EMAIL',
                qrCode:'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',
                qrLink: 'asd65asd654as5d4asd45sad4',
                mobile: '',
                options: [
                    {
                        name: 'ایمیل',
                        value: 'EMAIL'
                    },
                    {
                        name: 'پیامک',
                        value: 'SMS'
                    },
                    {
                        name: 'شناسایی دو عاملی گوگل',
                        value: 'GOOGLE_AUTHENTICATOR'
                    },
                ]
            }
        },
        methods: {
            async getTwoStepAuth() {
                // this.twoStep = this.state.userInfo.towStepAuthenticationType
                this.twoStep = 'EMAIL'
            },
            async showModal() {
                // this.state.loading = true
                // const [res,err] = await this.$http.post(`/users/send-verification-code?twoStepAuthorization=${this.twoStep}`)
                // if(err){
                //     await this.getTwoStepAuth()
                // }
                // if (res) {
                //     this.mobile = res.baseDTO.starTwoStepAuthentication || ''
                //     this.qrCode = res.baseDTO.file || ''
                //     this.qrLink = res.baseDTO.qrCodeLink ? res.baseDTO.qrCodeLink.match(/secret=(.*?)&/)[1] : ''
                //     if (res.message === 'Verification Code Sent') {
                this.modal = this.twoStep
                //     }
                // }
            },
            async submitted(e) {
                this.modal = false
                const text = `شناسایی دوعاملی به ${e.name} تغییر یافت.`;
                await this.$error('', text, 'success', '', '', 2500)
                this.twoStep = e.value
            }
        },
        mounted() {
            this.getTwoStepAuth()
        }
    }
</script>

<style lang="scss">
    .set-two-step-auth {
        background-color: var(--dark);
        padding: 25px;

        .label {
            .icon {
                padding: 4px;
                height: 28px;
                width: 28px;
            }
        }

        .two-step-radio {
            height: 35px;
            cursor: pointer;
            position: relative;
            background-color: var(--side-item);
            border-radius: 22px;

            b {
                position: absolute;
                inset: 0;
                border: 1px solid var(--white);
                border-radius: inherit;
                z-index: 0;
            }

            span {
                border-radius: 50%;
                border: 2px solid var(--white);
                height: 18px;
                width: 18px;
                position: relative;

                i {
                    content: '';
                    position: absolute;
                    background-color: transparent;
                    height: 100%;
                    width: 100%;
                    border-radius: 50%;
                    border: 2px solid var(--side-item);
                    left: 0;
                    top: 0;
                    transition: background-color 0.3s;
                }
            }

            &:hover {
                span {
                    i {
                        background-color: var(--white);
                    }
                }
            }

            input:checked ~ {
                span {
                    border-color: var(--yellow);

                    i {
                        background-color: var(--yellow);
                    }
                }

                b {
                    border-color: var(--yellow);
                }
            }
        }
    }
</style>